export default "__VITE_ASSET__Cxm$42S1__"